module.exports = __webpack_public_path__ + "static/daisy-7889630c97f82d4a4a1c71239839dad5.jpg";